<template>
  <button class="promptpai-snippet-button">
    <img class="promptpai-snippet-logo" :src="util.getImagePath('promptpai_icon_badge@2x.png')" :srcset="util.getImageSet('promptpai_icon_badge')">
    <!-- <div class="promptpai-snippet-id" :title="$t('PromptPaiSnippetButton.title')">{{ displayId }}</div> -->
    <div class="promptpai-snippet-id">{{ displayId }}</div>
  </button>
</template>

<script>
export default {
  name: 'PromptPaiSnippetButton',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayId () {
      var self = this
      if (self.id.length === 8) {
        return self.id.substring(0, 4) + ' ' + self.id.substring(4, 8)
      } else {
        return ''
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .promptpai-snippet-button {
    white-space: nowrap;
    background-color: rgb(255, 255, 255);
    border-radius: 18px;
    display: flex;
    flex-direction: row;
    padding: 0px;
    width: max-content;
    border: none;
    border: 1px solid #1E529E;
    box-sizing: border-box;
  }

  .promptpai-snippet-logo {
    height: 18px;
    margin: 1px 5px 1px 4px;
  }

  .promptpai-snippet-id {
    font-size: 12px;
    white-space: nowrap;
    margin: 2px 11px 0px 0px;
    text-decoration: none;
    color: #1E529E;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/PromptPaiSnippetButton.vue